import { FC, useState } from "react";
import { Box, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Transition from "../../Transition";
import { useStyles } from "./styles";
import { IMenuItem } from "../../../types/ui";
import MobileDropdown from "../../MobileDropdown";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  items: IMenuItem[];
  onClose: () => void;
}

const MobileMenu: FC<Props> = ({ open, items, onClose }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [selected, setSelected] = useState<string>();

  const handleCloseItem = () => setSelected(undefined);

  const handleCloseMenu = () => {
    handleCloseItem();
    onClose();
  };

  const handleClickItem = (href?: string) => {
    onClose();
    handleCloseItem();

    if (!href) return;

    if (href.includes("://")) {
      window.open(href, "_blank");
    } else {
      navigate(href);
    }
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
    >
      <Box className={classes.root}>
        <Box className={classes.close} onClick={handleCloseMenu}>
          <CloseIcon fontSize="medium" htmlColor="#25246D" />
        </Box>
        <Box>
          {items.map((item) => (
            <MobileDropdown
              {...item}
              key={item.id}
              open={item.id === selected}
              onOpen={setSelected}
              onClose={handleCloseItem}
              onClickItem={handleClickItem}
            />
          ))}
        </Box>
      </Box>
    </Dialog>
  );
};
export default MobileMenu;
